var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer-wrapper"},[_c('van-loading',{attrs:{"type":"spinner","color":"#1989fa"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }